export default {
  zone: {
    default: "Zone | Zones",
    list: {
      page_title: "Liste des zones",
      toString: "Codes postaux"
    },
    show: {
      page_title: "Fiche Zone :",
      toString: "Codes postaux",
      button: "Voir la fiche"
    },
    alert: {
      verb: {
        created: "créée",
        updated: "modifiée",
      },
      msg: "La zone {name} a bien été {verb}."
    },
    name: {
      placeholder: "Nom de la zone"
    },
    select: {
      placeholder: "Saisir un code postal ou une ville",
      empty: "Aucune zone"
    }
  }
}
